import * as React from 'react';
import Carousel from "@ingka/carousel";
import TouchCarousel, { clamp } from 'react-touch-carousel'
import { SingleItem } from './singleItem';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import touchWithMouseHOC from "react-touch-carousel/lib/touchWithMouseHOC";

export const CarouselComponent = ({ items }: any) => {

  const [autoplay, setAutoplay] = useState(true)

  const enableLoop = true;
  const cardSize = 300
  const cardPadCount = enableLoop ? 3 : 0
  const carouselWidth = clamp(window.innerWidth, 0, 960)

  function CarouselContainer(props) {
    const { cursor, carouselState: { active, dragging }, ...rest } = props
    let current = -Math.round(cursor) % items.length
    while (current < 0) {
      current += items.length
    }
    const translateX = (cursor - cardPadCount) * cardSize + (carouselWidth - cardSize) / 2

    return (
        <div className="container-fluid list">
      
                <div className='carousel-container'>
                    <div
                        className='carousel-track'
                        style={{ transform: `translate3d(${translateX}px, 0, 0)` }}
                        {...rest}
                    />
                    <div className='carousel-pagination-wrapper'>
                        <ol className='carousel-pagination'>
                            {items.map((_, index) => (
                            <li
                                key={index}
                                className={current === index ? 'current' : ''}
                            />
                            ))}
                        </ol>
                    </div>
                </div>
          
        </div>
    )
  }

  const Container = touchWithMouseHOC(CarouselContainer);

  function renderCard(index, modIndex) {
    const item = items[modIndex]
    return (
      <Link
        to={"/product/" + item.sectionProductId}
        className='col'
        key={index}
        onClick={() => console.log(`clicked card ${1 + modIndex}`)}
      >
        <SingleItem item={item} />
      </Link>
    )
  }

  const handleOnIdle = () => {
    const time = getRemainingTime()
    if (time == 0) {
      setAutoplay(true)
    }
  }

  const handleOnActive = () => {
    setAutoplay(false)
  }

  const { getRemainingTime } = useIdleTimer({
    timeout: parseInt(process.env.IDLE),
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500
  })


  return (
    <>
      <TouchCarousel
        component={Container}
        cardSize={cardSize}
        cardCount={items.length}
        cardPadCount={cardPadCount}
        loop={enableLoop}
        autoplay={autoplay ? 3000 : false}
        renderCard={renderCard}
        //onRest={index => console.log(`rest at index ${index}`)}
        //onDragStart={() => console.log('dragStart')}
        //onDragEnd={() => console.log('dragEnd')}
        //onDragCancel={() => console.log('dragCancel')}
      />

      {/* <div className='list-carousel'>
        <Carousel
          children={items.map((item: any) => <Link to={"/product/" + item.id} className='col'><SingleItem item={item} /></Link>)}
        />
      </div> */}
    </>
  )
}
